<template lang="pug">
.flex-centered.full-height
  .loading.loading-lg
</template>

<script>
import { LocalStorageFacade } from "paliari-js-utils";

export default {
  methods: {
    async redirect() {
      await this.$auth.current();
      this.$router.replace({ name: "app.home" });
    },
  },
  created() {
    if (this.$route.query && this.$route.query._t) {
      LocalStorageFacade.setItem("portal_auth_token", this.$route.query._t);
    }
    this.redirect();
  },
};
</script>
